import {
  SchemaModel,
  StringType,
  NumberType,
  ArrayType,
  DateType,
  ObjectType,
  BooleanType
} from 'schema-typed';

const SchemaTyped = {
  Model: SchemaModel,
  Types: {
    StringType,
    NumberType,
    ArrayType,
    DateType,
    ObjectType,
    BooleanType
  }
};

export default SchemaTyped;
